export const validateName = async (value) => {
    const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
    if (!nameRegex.test(value)) {
      return false;
    } else {
        return true;
    }
};

export const validateEmail = async (value) => {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!emailRegex.test(value)) {
      return false;
    } else {
        return true;
    }
};

export const validateDate = async (value) => {
    const dateRegex = /^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d$/;
    if (!dateRegex.test(value)) {
      return false;
    } else {
        return true;
    }
};
export const validatePhone = async (value) => {
    const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    if (!phoneRegex.test(value)) {
      return false;
    } else {
        return true;
    }
};
export const validatePassword = async (value) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z]).{6,}$/;
    if (!passwordRegex.test(value)) {
      return false;
    } else {
        return true;
    }
};
